// import React, { useState, useEffect } from 'react';
// import { usersAPI } from '../services/componentServices'; 

// const UserManagement = ({ users, setUsers, currentUser }) => {
//   const [showModal, setShowModal] = useState(false);
//   const [newUser, setNewUser] = useState({ username: '', password: '', role: 'user' });
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);

//   const fetchUsers = async () => {
//     try {
//       setLoading(true);
//       const usersData = await usersAPI.fetchAll();
//       setUsers(usersData);
//     } catch (err) {
//       console.error('Error fetching users:', err);
//       setError('Unable to fetch users from server');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const handleAddUser = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);

//     try {
//       await usersAPI.create(newUser);
//       await fetchUsers();
//       setNewUser({ username: '', password: '', role: 'user' });
//       setShowModal(false);
//       setError('');
//     } catch (err) {
//       console.error('Error creating user:', err);
//       setError(err.message || 'Unable to create user');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDeleteUser = async (userId) => {
//     if (userId === currentUser.id) {
//       setError('Cannot delete your own account');
//       return;
//     }

//     if (!window.confirm('Are you sure you want to delete this user?')) {
//       return;
//     }

//     try {
//       setLoading(true);
//       await usersAPI.delete(userId);
//       await fetchUsers();
//     } catch (err) {
//       console.error('Error deleting user:', err);
//       setError(err.message || 'Unable to delete user');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChangePassword = async (userId, newPassword) => {
//     try {
//       const user = users.find(u => u.id === userId);
//       await usersAPI.changePassword(currentUser.username, user.username, newPassword);
//       alert('Password changed successfully');
//     } catch (err) {
//       console.error('Error changing password:', err);
//       setError(err.message || 'Unable to change password');
//     }
//   };

//   return (
//     <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-200">
//       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
//         <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
//           <svg className="w-5 h-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
//             <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
//           </svg>
//           User Management
//         </h2>
//         <button
//           onClick={() => setShowModal(true)}
//           className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium save-all-btn flex items-center gap-2 justify-center w-full sm:w-auto"
//         >
//           <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
//           </svg>
//           Add User
//         </button>
//       </div>

//       {error && (
//         <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
//           <div className="flex items-center">
//             <svg className="w-5 h-5 text-red-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
//               <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
//             </svg>
//             <span className="text-sm text-red-700">{error}</span>
//           </div>
//         </div>
//       )}

//       {loading && (
//         <div className="flex justify-center items-center py-4">
//           <svg className="animate-spin h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24">
//             <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//             <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//           </svg>
//         </div>
//       )}

//       <div className="sm:hidden space-y-3">
//         {users.map((user) => (
//           <div key={user.id} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
//             <div className="flex justify-between items-start mb-2">
//               <div className="flex items-center gap-2">
//                 <span className="font-medium text-gray-900">{user.username}</span>
//                 {user.id === currentUser.id && (
//                   <span className="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full">Current</span>
//                 )}
//               </div>
//               <span className={`px-2 py-1 text-xs rounded-full ${
//                 user.role === 'admin' 
//                   ? 'bg-purple-100 text-purple-800' 
//                   : 'bg-green-100 text-green-800'
//               }`}>
//                 {user.role}
//               </span>
//             </div>
//             <div className="flex justify-between items-center">
//               <span className="text-sm text-gray-600">ID: {user.id}</span>
//               {user.id !== currentUser.id && (
//                 <button
//                   onClick={() => handleDeleteUser(user.id)}
//                   className="px-3 py-1 text-red-600 hover:text-red-800 transition-colors text-sm"
//                   disabled={loading}
//                 >
//                   Delete
//                 </button>
//               )}
//             </div>
//           </div>
//         ))}
//       </div>

//       <div className="hidden sm:block overflow-x-auto">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead>
//             <tr>
//               <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Username</th>
//               <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
//               <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {users.map((user) => (
//               <tr key={user.id}>
//                 <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
//                   <div className="flex items-center gap-2">
//                     {user.username}
//                     {user.id === currentUser.id && (
//                       <span className="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full">Current</span>
//                     )}
//                   </div>
//                 </td>
//                 <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
//                   <span className={`px-2 py-1 text-xs rounded-full ${
//                     user.role === 'admin' 
//                       ? 'bg-purple-100 text-purple-800' 
//                       : 'bg-green-100 text-green-800'
//                   }`}>
//                     {user.role}
//                   </span>
//                 </td>
//                 <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
//                   {user.id !== currentUser.id && (
//                     <button
//                       onClick={() => handleDeleteUser(user.id)}
//                       className="px-3 py-1 text-red-600 hover:text-red-800 transition-colors"
//                       disabled={loading}
//                     >
//                       Delete
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {showModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-xl p-4 sm:p-6 w-full max-w-md mx-2 sm:mx-0 max-h-[90vh] overflow-y-auto">
//             <h3 className="text-lg font-semibold text-gray-900 mb-4">Add New User</h3>
            
//             {error && (
//               <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
//                 <div className="flex items-center">
//                   <svg className="w-5 h-5 text-red-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
//                   </svg>
//                   <span className="text-sm text-red-700">{error}</span>
//                 </div>
//               </div>
//             )}

//             <form onSubmit={handleAddUser} className="space-y-4" style={{padding:'10px'}}>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
//                 <input
//                   type="text"
//                   placeholder='Enter username'
//                   value={newUser.username}
//                   onChange={(e) => setNewUser({...newUser, username: e.target.value})}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
//                 <input
//                   type="password"
//                   placeholder='Enter password'
//                   value={newUser.password}
//                   onChange={(e) => setNewUser({...newUser, password: e.target.value})}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
//                 <select
//                   value={newUser.role}
//                   onChange={(e) => setNewUser({...newUser, role: e.target.value})}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                 >
//                   <option value="user">User</option>
//                   <option value="admin">Admin</option>
//                 </select>
//               </div>

//               <div className="flex flex-col sm:flex-row gap-3 pt-4">
//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-lg font-medium save-all-btn items-center flex justify-center order-2 sm:order-1"
//                 >
//                   {loading ? 'Adding...' : 'Add User'}
//                 </button>
//                 <button
//                   type="button"
//                   onClick={() => setShowModal(false)}
//                   disabled={loading}
//                   className="flex-1 py-2 px-4 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 disabled:opacity-50 transition-colors order-1 sm:order-2"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserManagement;

import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import Header from '../components/Header';
import Login from '../components/Login';
import { usersAPI } from '../services/componentServices';
import useLogout from '../hooks/useLogout';
import LogoutConfirmModal from '../components/LogoutConfirmModal';

const UserManagementPage = ({
    currentUser,
    onLogout,
    onShowUserManagement,
    onTabChange,
    activeTab,
    sidebarOpen,
    onToggleSidebar
}) => {
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [newUser, setNewUser] = useState({ username: '', password: '', role: 'user' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // Use the logout hook
    const {
        showLogoutConfirm,
        handleLogoutClick,
        handleConfirmLogout,
        handleCancelLogout
    } = useLogout(onLogout);

    const fetchUsers = async () => {
        try {
            setLoading(true);
            const usersData = await usersAPI.fetchAll();
            setUsers(usersData);
        } catch (err) {
            console.error('Error fetching users:', err);
            setError('Unable to fetch users from server');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (currentUser) {
            fetchUsers();
        }
    }, [currentUser]);

    const handleAddUser = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await usersAPI.create(newUser);
            await fetchUsers();
            setNewUser({ username: '', password: '', role: 'user' });
            setShowModal(false);
            setError('');
        } catch (err) {
            console.error('Error creating user:', err);
            setError(err.message || 'Unable to create user');
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteUser = async (userId) => {
        if (userId === currentUser.id) {
            setError('Cannot delete your own account');
            return;
        }

        if (!window.confirm('Are you sure you want to delete this user?')) {
            return;
        }

        try {
            setLoading(true);
            await usersAPI.delete(userId);
            await fetchUsers();
        } catch (err) {
            console.error('Error deleting user:', err);
            setError(err.message || 'Unable to delete user');
        } finally {
            setLoading(false);
        }
    };

    const handleChangePassword = async (userId, newPassword) => {
        try {
            const user = users.find(u => u.id === userId);
            await usersAPI.changePassword(currentUser.username, user.username, newPassword);
            alert('Password changed successfully');
        } catch (err) {
            console.error('Error changing password:', err);
            setError(err.message || 'Unable to change password');
        }
    };

    // If no current user, show login page
    if (!currentUser) {
        return <Login onLogin={() => { }} users={[]} setUsers={() => { }} />;
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex">
            <Navigation
                currentUser={currentUser}
                activeTab={activeTab}
                onTabChange={onTabChange}
                onLogout={handleLogoutClick}
                onShowUserManagement={onShowUserManagement}
                sidebarOpen={sidebarOpen}
                onToggleSidebar={onToggleSidebar}
            />

            <div className="flex-1 flex flex-col lg:ml-0">
                <Header
                    currentUser={currentUser}
                    onToggleSidebar={onToggleSidebar}
                />

                <main className="flex-1 p-4 sm:p-6 overflow-auto">
                    <div className="max-w-7xl mx-auto w-full">
                        <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg border border-gray-100 overflow-hidden transition-all duration-300">
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-4 sm:px-6 py-4 sm:py-5 border-b border-gray-200">
                                <div className="flex items-center gap-3 sm:gap-4">
                                    <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 flex items-center justify-center flex-shrink-0">
                                        <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h1 className="text-xl sm:text-2xl font-bold text-gray-900">User Management</h1>
                                        <p className="text-sm text-gray-600 mt-1">Manage system users and permissions</p>
                                    </div>
                                </div>
                            </div>

                            <div className="p-4 sm:p-6">
                                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
                                    <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                                        <svg className="w-5 h-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                        </svg>
                                        System Users
                                    </h2>
                                    <button
                                        onClick={() => setShowModal(true)}
                                        className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium save-all-btn flex items-center gap-2 justify-center w-full sm:w-auto hover:bg-blue-700 transition-colors"
                                    >
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                        </svg>
                                        Add User
                                    </button>
                                </div>

                                {error && (
                                    <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl">
                                        <div className="flex items-center">
                                            <svg className="w-5 h-5 text-red-400 mr-3" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                            </svg>
                                            <span className="text-sm text-red-700">{error}</span>
                                        </div>
                                    </div>
                                )}

                                {loading && (
                                    <div className="flex justify-center items-center py-8">
                                        <div className="text-center">
                                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
                                            <p className="mt-4 text-gray-600">Loading users...</p>
                                        </div>
                                    </div>
                                )}

                                {/* Mobile View */}
                                <div className="sm:hidden space-y-4">
                                    {users.map((user) => (
                                        <div key={user.id} className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                                            <div className="flex justify-between items-start mb-3">
                                                <div className="flex items-center gap-2">
                                                    <span className="font-medium text-gray-900">{user.username}</span>
                                                    {user.id === currentUser.id && (
                                                        <span className="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full">Current</span>
                                                    )}
                                                </div>
                                                <span className={`px-2 py-1 text-xs rounded-full ${
                                                    user.role === 'admin' 
                                                        ? 'bg-purple-100 text-purple-800' 
                                                        : 'bg-green-100 text-green-800'
                                                }`}>
                                                    {user.role}
                                                </span>
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <span className="text-sm text-gray-600">ID: {user.id.slice(0, 8)}...</span>
                                                {user.id !== currentUser.id && (
                                                    <button
                                                        onClick={() => handleDeleteUser(user.id)}
                                                        className="px-3 py-1 text-red-600 hover:text-red-800 transition-colors text-sm font-medium"
                                                        disabled={loading}
                                                    >
                                                        Delete
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Desktop View */}
                                <div className="hidden sm:block overflow-x-auto rounded-lg border border-gray-200">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Username</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {users.map((user) => (
                                                <tr key={user.id} className="hover:bg-gray-50 transition-colors">
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="flex items-center gap-2">
                                                            <span className="text-sm font-medium text-gray-900">{user.username}</span>
                                                            {user.id === currentUser.id && (
                                                                <span className="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full">Current</span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <span className={`px-3 py-1 text-xs rounded-full font-medium ${
                                                            user.role === 'admin' 
                                                                ? 'bg-purple-100 text-purple-800' 
                                                                : 'bg-green-100 text-green-800'
                                                        }`}>
                                                            {user.role}
                                                        </span>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                        {user.id !== currentUser.id && (
                                                            <button
                                                                onClick={() => handleDeleteUser(user.id)}
                                                                className="text-red-600 hover:text-red-800 transition-colors font-medium disabled:opacity-50"
                                                                disabled={loading}
                                                            >
                                                                Delete User
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {users.length === 0 && !loading && (
                                    <div className="text-center py-12">
                                        <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                                        </svg>
                                        <h3 className="text-lg font-medium text-gray-900 mb-2">No users found</h3>
                                        <p className="text-gray-500 mb-4">Get started by adding your first user</p>
                                        <button
                                            onClick={() => setShowModal(true)}
                                            className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium save-all-btn flex items-center gap-2 justify-center mx-auto hover:bg-blue-700 transition-colors"
                                        >
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                            </svg>
                                            Add First User
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </main>
            </div>

            {/* Add User Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                    <div className="bg-white rounded-xl p-6 w-full max-w-md mx-2 sm:mx-0 max-h-[90vh] overflow-y-auto">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">Add New User</h3>
                        
                        {error && (
                            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                                <div className="flex items-center">
                                    <svg className="w-5 h-5 text-red-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                    </svg>
                                    <span className="text-sm text-red-700">{error}</span>
                                </div>
                            </div>
                        )}

                        <form onSubmit={handleAddUser} className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
                                <input
                                    type="text"
                                    placeholder='Enter username'
                                    value={newUser.username}
                                    onChange={(e) => setNewUser({...newUser, username: e.target.value})}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                                <input
                                    type="password"
                                    placeholder='Enter password'
                                    value={newUser.password}
                                    onChange={(e) => setNewUser({...newUser, password: e.target.value})}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
                                <select
                                    value={newUser.role}
                                    onChange={(e) => setNewUser({...newUser, role: e.target.value})}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                                >
                                    <option value="user">User</option>
                                    <option value="admin">Admin</option>
                                </select>
                            </div>

                            <div className="flex flex-col sm:flex-row gap-3 pt-4">
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-lg font-medium save-all-btn items-center flex justify-center hover:bg-blue-700 transition-colors disabled:opacity-50 order-2 sm:order-1"
                                >
                                    {loading ? (
                                        <>
                                            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Adding...
                                        </>
                                    ) : 'Add User'}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setShowModal(false)}
                                    disabled={loading}
                                    className="flex-1 py-2 px-4 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 disabled:opacity-50 transition-colors order-1 sm:order-2"
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <LogoutConfirmModal 
                isOpen={showLogoutConfirm}
                onConfirm={handleConfirmLogout}
                onCancel={handleCancelLogout}
            />
        </div>
    );
};

export default UserManagementPage;